export { ClickAndCollectInfoModalPresenter } from './ClickAndCollectInfoModalPresenter'
